import { styled } from "@mui/material/styles";

export const ItemsWrapper = styled("ul", {
  label: "items-wrapper",
})`
  list-style: none;
  padding-inline-start: 0px;
  display: flex;
  flex-direction: column;

  &.columns {
    flex-direction: row;
    column-gap: ${({ theme }) => theme.spacing(10)};

    & li:last-child {
      border-bottom: none;
    }
  }
`;

export const Column = styled("div", {
  label: "column",
})`
  flex: 1;
  display: flex;
  flex-direction: column;

  :last-of-type > li:last-of-type {
    border-bottom: none;
  }
`;
